import { NavigationPath } from '@models/routes'
import * as React from 'react'
import { connect } from 'react-redux'
import { Redirect, Route, RouteComponentProps, RouteProps } from 'react-router-dom'
import { RootState } from '@store/index'

interface ReduxProps {
  isAuth: boolean
}

interface ComponentProps {
  component: React.ComponentType<RouteComponentProps<{}>> | React.ComponentType<unknown>
}

export type Props = ComponentProps & RouteProps & ReduxProps

export class PrivateRouteComponent extends React.Component<Props, {}> {
  public render(): React.ReactNode {
    const { component: Component, ...rest } = this.props

    const nextQuery = `?next=${this.props.location?.pathname}${this.props.location?.search}`
    return (
      <Route
        {...rest}
        render={props =>
          this.props.isAuth ? <Component {...props} /> : <Redirect to={`${NavigationPath.Login}${nextQuery}`} />
        }
      />
    )
  }
}

const mapStateToProps = (state: RootState): ReduxProps => ({
  isAuth: state.authState.isAuth,
})

const PrivateRoute = connect(mapStateToProps)(PrivateRouteComponent)

export default PrivateRoute
